import { Login } from 'Pages/Login'
import { ReminderList } from 'Components/User/ReminderList'
import { Box, Typography } from '@mui/material'
import { useAccountId } from 'ContextProviders/CurrentAccount'
import { RecentlyCreatedDuplicates } from 'Components/DuplicateHandling/RecentlyCreatedDuplicates'
import { MyCreatedDuplicates } from 'Components/DuplicateHandling/MyCreatedDuplicates'
import { useAuth } from 'hooks/use-auth'
import { usePermissions } from 'hooks/use-permissions'
import { Role } from 'core/types'
import { MyAccessRequests } from 'Components/DuplicateHandling/MyaccessRequests'

export function AboutPage (): JSX.Element {
  const { user } = useAuth()
  const perms = usePermissions()

  return <>
    <Typography variant="h3" data-testid='homepageLabel'>{useAccountId()?.type} Home</Typography>
    <Box sx={{ marginTop: '10px' }}>
      <Login />
    </Box>
    {user != null &&
      <>
        <Box sx={{ marginTop: '15px' }}>
          <ReminderList />
        </Box>
        <Box sx={{ marginTop: '15px' }}>
          {(perms.ISDs_DuplicateHandling || user.securityLevel === Role.MIECC_ADMIN) && <RecentlyCreatedDuplicates />}
          {!perms.ISDs_DuplicateHandling && user.securityLevel !== Role.CARE_GIVER && user.securityLevel !== Role.MIECC_ADMIN && <MyCreatedDuplicates />}
          {perms.ISDs_Approvals && user.securityLevel === Role.ISD_USER && <MyAccessRequests />}
        </Box>
      </>
    }
  </>
}
